/**
 * Allegati di una nota in sola lettura: sempre visibili sotto il testo, anche quando
 * il testo è troncato ("Mostra di più"), con un'intestazione che dice quanti sono.
 * Caso reale (riunione 28/09): due Excel in una nota non si vedevano senza ridurre lo zoom.
 */
import React from 'react';
import { Paperclip } from 'lucide-react';
import { AttachmentFileRow } from './AttachmentFileRow';
import type { AttachmentLike } from '../../../lib/utils/noteAttachmentFiles';

interface NoteAttachmentListProps {
  attachments: AttachmentLike[] | null | undefined;
}

export const NoteAttachmentList: React.FC<NoteAttachmentListProps> = ({ attachments }) => {
  if (!attachments || attachments.length === 0) return null;
  return (
    <div className="mt-2.5 border-t border-[rgba(55,53,47,0.09)] dark:border-[#3F4447] pt-2">
      <div className="mb-1.5 flex items-center gap-1 text-[11px] font-medium text-[#787774] dark:text-gray-400">
        <Paperclip className="h-3 w-3" strokeWidth={1.75} />
        {attachments.length === 1 ? '1 allegato' : `${attachments.length} allegati`}
      </div>
      <div className="space-y-1.5">
        {attachments.map((att) => (
          <AttachmentFileRow key={att.id} attachment={att} />
        ))}
      </div>
    </div>
  );
};
